import React from "react";

import "./sidebar-top.css";

import { ReactComponent as RunSvg } from '../assets/i_run.svg';
import { ReactComponent as DistanceSvg } from '../assets/i_distance.svg';
import { ReactComponent as ClockSvg } from '../assets/i_clock.svg';
import { ReactComponent as AverageSvg } from '../assets/carbon_chart-average.svg';
import { ReactComponent as UpSvg } from '../assets/icons_arrow_up.svg';
import { ReactComponent as DownSvg } from '../assets/icons_arrow_down.svg';

const SidebarTop = ({
  id,
  activityDetails,
  userPrefUnits,
}) => {
  return (
    <>
      {id && activityDetails && (
        <div className="styledContainer">
          <div className="styledItem">
            <i className="activity_icons"><ClockSvg /></i>
            {activityDetails.activityTime ? activityDetails.activityTime : " -- "} h
          </div>
          <div className="styledItem">
            <i className="activity_icons"><RunSvg /></i>
            {activityDetails.paceTime ? activityDetails.paceTime : " -- "}{" "} 
            {userPrefUnits[0]}              
          </div>
          <div className="styledItem">
            <i className="activity_icons"><DistanceSvg /></i>
            {activityDetails.totalDistanceRounded ? activityDetails.totalDistanceRounded : " -- "}{" "}
            {userPrefUnits[1]}
          </div>
          <div className="styledItem">
            <i className="activity_icons"><UpSvg /></i>
            {activityDetails.totalPositiveElevationRounded ? activityDetails.totalPositiveElevationRounded : " -- "}{" "}
            {userPrefUnits[2]}
          </div>
          <div className="styledItem">
          <i className="activity_icons"><DownSvg /></i>
            {activityDetails.totalNegativeElevationRounded ? activityDetails.totalNegativeElevationRounded : " -- "}{" "}
            {userPrefUnits[2]}
          </div>
          <div className="styledItem">
          <i className="activity_icons"><AverageSvg /></i>
            {activityDetails.averageElevationRounded ? activityDetails.averageElevationRounded : " -- "}{" "}
            {userPrefUnits[2]}
          </div>
        </div>
      )}
    </>
    );
};

export default SidebarTop;
